<div class="spinner" *ngIf="isLoading; else showTopOffersDashboard"></div>
<ng-template #showTopOffersDashboard>
  <div class="wellbeing-partners-wrapper">
    <div class="heading-wrapper">
      <h2 class="heading bold">{{ pageData.page_title }}</h2>
      <h2 class="intro">
        {{ pageData.cards?.length + ' ' + pageData.page_intro }}
      </h2>
    </div>

    <ng-container *ngFor="let card of pageData.cards; let i = index">
      <div class="card-wrapper">
        <div class="heading-box white-bg margin-center">
          <img class="icon" [src]="card.icon?.data?.attributes?.url" />
          <h1 class="card-heading-text">{{ card.card_title }}</h1>
        </div>
        <p class="excert margin-center bold">{{ card.card_excerpt }}</p>
        <div class="button-container margin-center">
          <a
            class="button dashboard-btn"
            [href]="card.external_link ? card.external_link : card.web_route"
            >{{ card.card_button_text ?? 'Find out more' }}</a
          >
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
